import { Component, OnInit, signal, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { COMMON_IMPORTS } from '../../../Shared/common-imports';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../Shared/Services/auth.service';
import { endpoints } from '../../../../../environments/endpoints';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [...COMMON_IMPORTS,],
})
export class LoginComponent {
  isLoading = signal<boolean>(false);

  loginWithMicrosoft(): void {
    this.isLoading.set(true);

    try {
      window.location.href = `${environment.coreApi.host}/${endpoints.auth.loginRedirect}`;
    } catch (error) {
      console.error('Navigation error:', error);
      this.isLoading.set(false);
    }
  }
}
